<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black" :to="{ name: 'dashboard' } ">
                      <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">重要管理項目および健康身だしなみ</p>
                </div>
            </div>
        </div>
        <DashboardCookingHealthList :start-date="startDate" :end-date="endDate"/>
    </div>
</template>

<script>
    import DashboardCookingHealthList from '@/app/components/DashboardCookingHealthList.vue'

    export default {
        name: 'dashboardCookingHealthListIndex',
        props: {
          startDate: String,
          endDate: String,
        },
        components: {
          DashboardCookingHealthList
        },
    }
</script>
